import { AuthService } from 'app/services';

function SilentRenew() {
  AuthService.signInSilentCallback();
  return <div></div>;
}

export default SilentRenew;
